export default __webpack_public_path__ + "static/media/win1.3fa1f9c8.gif";